import React from 'react';

export function ProjectCard({ title, description, imageUrl, tags = [], onClick, category, status }) {
  // derive in-progress from status (not from tags)
  const isInProgress = String(status ?? '').toLowerCase().includes('in progress');

  return (
    <div
      className="relative bg-white dark:bg-gray-700 rounded-lg shadow-md dark:shadow-lg dark:border dark:border-gray-600 overflow-hidden cursor-pointer transition-colors duration-300 flex flex-col"
      onClick={onClick}
    >
      {/* Card-level badge for In Progress */}
      {isInProgress && (
        <span className="absolute top-4 left-4 z-20 text-xs font-semibold px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-400 dark:text-yellow-900 shadow">
          In Progress
        </span>
      )}

      {/* Image */}
      <img src={imageUrl} alt={title} className="w-full h-64 object-cover" />

      {/* Content */}
      <div className="flex-grow p-6">
        <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">{title}</h3>
        <p className="text-gray-600 dark:text-gray-300">{description}</p>
        {/* show category */}
        {/* {category && <p className="mt-3 text-sm text-gray-500 dark:text-gray-300">Category: {category}</p>} */}
      </div>

      {/* Tags (technologies) */}
      <div className="p-4 border-t border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800">
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, index) => {
            const base = 'text-sm rounded-full px-3 py-1';
            const classes = `${base} bg-blue-100 text-blue-600 dark:bg-blue-400 dark:text-white`;

            return (
              <span key={index} className={classes}>
                {tag}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}
 